var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Glyphs/Add Folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyphs/Add-Folder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-delete-cross",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 26 0 26 26 0 26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25,20.5833333 L20.5833333,20.5833333 C21.7799503,20.5833333 22.75,19.6132836 22.75,18.4166667 L22.75,8.60166667 C22.75,7.40504971 21.7799503,6.435 20.5833333,6.435 L13.5730833,6.435 C13.2131218,6.43518261 12.8765784,6.25655886 12.675,5.95833333 L11.1583333,3.72341667 C10.956019,3.42642651 10.6196014,3.24908692 10.26025,3.24999649 L5.41666667,3.24999649 C4.22004971,3.24999649 3.25,4.22004971 3.25,5.41666667 L3.25,10.8333333",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.20833333,
    y1: 16.8189546,
    x2: 7.13483333,
    y2: 18.8924546,
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(8.171583, 17.855705) rotate(-315.000000) translate(-8.171583, -17.855705) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.13483333,
    y1: 16.8189546,
    x2: 9.20833333,
    y2: 18.8924546,
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(8.171583, 17.855705) rotate(-315.000000) translate(-8.171583, -17.855705) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,17.875 C13,20.5673882 10.8173882,22.75 8.125,22.75 C5.43261184,22.75 3.25,20.5673882 3.25,17.875 C3.25,15.1826118 5.43261184,13 8.125,13 C9.41793039,13 10.6579057,13.5136146 11.5721456,14.4278544 C12.4863854,15.3420943 13,16.5820696 13,17.875",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/add_folder.0553558f.svg";
export { ForwardRef as ReactComponent };